import { render } from "./SliderCustom.vue?vue&type=template&id=5a58eb14"
import script from "./SliderCustom.vue?vue&type=script&lang=js"
export * from "./SliderCustom.vue?vue&type=script&lang=js"

import "./SliderCustom.vue?vue&type=style&index=0&id=5a58eb14&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__